import { startCase } from 'lodash';
import type React from 'react';

import { emailLink as emailLinkBuilder } from '@swf/core/utils';

interface Email {
  emailText?: string;
  emailLink?: React.ReactElement;
}

export const interpolate = ['support', 'security', 'verification', 'wecare'].map((type) => ({
  getEmail: (domain: string, starsDomain: string) =>
    `${type}@${!domain || domain === 'starsdomain' ? starsDomain : domain}`,
  type,
  resolve: `contactUsMail${startCase(type)}Starsdomain`
}));

export const emailTagTransform = (
  key: string,
  resolved: string | null,
  domain: string | undefined | null,
  starsDomain: string
): Email => {
  let emailLink;
  let emailText;

  const textInterpolation = interpolate.find(({ type }) => {
    const lookingForKey = `contactUsText${startCase(type)}Starsdomain`;
    return key === lookingForKey;
  });

  if (textInterpolation) {
    emailText = textInterpolation.getEmail(domain || '', starsDomain);
  }

  const mailInterpolation = interpolate.find(({ type }) => {
    const lookingForKey = `contactUsMail${startCase(type)}Starsdomain`;
    return key === lookingForKey || key === 'contactUsMail' || resolved === lookingForKey;
  });

  if (mailInterpolation) {
    const email = mailInterpolation.getEmail(domain || '', starsDomain);
    emailLink = emailLinkBuilder(email);
  }

  return { emailLink, emailText };
};
